import { Component, inject } from '@angular/core';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { ModalContainerComponent } from '../modal-container/modal-container.component';
import { ConfirmModalData } from 'app/shared/models/modal.models';
import { ButtonComponent } from '@kinomap-dev/ng-ui-lib/buttons';

@Component({
  selector: 'app-confirm-modal',
  imports: [ModalContainerComponent, ButtonComponent],
  templateUrl: './confirm-modal.component.html',
  styleUrl: './confirm-modal.component.scss',
})
export class ConfirmModalComponent {
  private dialogRef: DialogRef = inject(DialogRef);
  public data: ConfirmModalData = inject(DIALOG_DATA);

  get title(): string {
    return this.data?.title || '';
  }

  get message(): string {
    return this.data?.message || '';
  }

  get confirmText(): string {
    return this.data?.confirmText || 'Confirmer';
  }

  get cancelText(): string {
    return this.data?.cancelText || 'Annuler';
  }

  onConfirm(): void {
    if (this.data?.onConfirm) {
      this.data.onConfirm();
    }
    this.dialogRef.close();
  }

  onCancel(): void {
    if (this.data?.onCancel) {
      this.data.onCancel();
    }
    this.dialogRef.close();
  }
}
